import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './navbar.css';

function Navbar() {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };

  return (
    <div className="main-navbar-container">
      <nav className="navbar">
        <div className="navbar-logo">
          <Link to="/">
            <img src="/images/logo.jpg" alt="Logo" />
          </Link>
          <Link to="/">
            <p>OZ Zachráň zajka</p>
          </Link>
        </div>
        <div
          className={`menu-icon ${isOpen ? 'open' : ''}`}
          onClick={toggleMenu}
        >
          <div className="bar1"></div>
          <div className="bar2"></div>
          <div className="bar3"></div>
        </div>
        <ul className={`navbar-links ${isOpen ? 'active' : ''}`}>
          <li>
            <Link to="/" onClick={closeMenu}>
              O NÁS
            </Link>
          </li>
          <li className="dropdown">
            <Link to="/ako-pomoct" onClick={closeMenu}>
              AKO POMÔCŤ
            </Link>
          </li>
          <li>
            <Link to="/nasi-zajkovia" onClick={closeMenu}>
              NAŠI ZAJKOVIA
            </Link>{' '}
          </li>
          <li>
            <Link to="/kontakt" onClick={closeMenu}>
              KONTAKT
            </Link>
          </li>
        </ul>
        <div
          className={`close-menu ${isOpen ? 'show' : ''}`}
          onClick={closeMenu}
        >
          &times;
        </div>
      </nav>
    </div>
  );
}

export default Navbar;
